import styled from "styled-components";

export const LoginLayout = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
export const LoginInnerWrapperOther = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 80%;
`;
export const FlexWithGap = styled.div`
  display: flex;
  flex-direction: ${(props) =>
    props.flexDirection ? props.flexDirection : "column"};
  gap: ${(props) => props.gap && props.gap};
`;
export const FlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export const WidthWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  width: ${(props) => props.maxWidth && props.maxWidth};
  @media only screen and (max-width: 500px) {
    width: calc(100vw - 3rem);
  }
`;
export const OTPWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
export const OTPFieldsWrapper = styled.div`
  margin-left: 4rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media only screen and (max-width: 500px) {
    margin-left: 2rem;
  }
`;
